export default function cVideoControl() {
  const initVideoControls = () => {
    const playPauseButtons = document.querySelectorAll('.c-playpause');

    playPauseButtons.forEach((button) => {
      const videoId = button.getAttribute('aria-controls');
      const element = document.getElementById(videoId);

      if (!element || element.tagName !== 'VIDEO') return;

      element.addEventListener('play', () => {
        if (button.classList.contains('c-playpause')) {
          button.classList.remove('c-playpause--play');
          button.classList.add('c-playpause--pause');
        }

        button.setAttribute('aria-pressed', 'false');
      });

      element.addEventListener('pause', () => {
        if (button.classList.contains('c-playpause')) {
          button.classList.remove('c-playpause--pause');
          button.classList.add('c-playpause--play');
        }

        button.setAttribute('aria-pressed', 'true');
      });

      button.addEventListener('click', () => {
        if (element.paused) {
          element.play();
        } else {
          element.pause();
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVideoControls);
  } else {
    initVideoControls();
  }
}

cVideoControl();
